import { Component, OnInit, ViewChild } from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { IAssociated } from "app/models/core/lab/associated";
import { SharedService } from "app/services/core/shared.service";
import { LabService } from "app/services/lab/lab.service";



@Component({
  selector: 'app-hst',
  templateUrl: './hst.component.html'
})

export class HstComponent implements OnInit {

  list: IAssociated[] = [];
  displayedColumns: string[] = ['labName', 'stateNumber', 'cliaNumber', 'comments'];
  hstList: IAssociated[] = [];
  dataSource = new MatTableDataSource<IAssociated>(this.list);

  listFilter = '';
  editMode = 'list';
  inputComments = '';
  stateNumber = '';
  hstLabName = '';
  cliaNumber = '';
  isHstLab = false;
  hstId = 0;
  inputLab: IAssociated;

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public labService: LabService,
    public sharedService: SharedService) { };

  ngOnInit() {
    if (this.labService.lab != null) {
      this.setupTable();
    }
  }

  setupTable() {

    this.labService.getHstList(this.labService.lab.cliaNumber).subscribe(
      res => {
        this.hstList = res;
        this.list = this.labService.associated.hstList;
        this.dataSource.data = this.list;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.isHstLab = this.labService.lab.labType == '10';
      },
      error => console.log('error: ', error),
      () => {
      }
    );
  }

  addHst() {
    this.editMode = 'add';
  }

  save() {
    if (this.inputLab != null) {
      // this.inputLab.hstLabId = this.inputLab.labId;
      this.inputLab.labId = this.labService.lab.labId;
      this.inputLab.comments = this.inputComments;
      this.labService.saveAssociatedLab(this.inputLab, 'HST').subscribe(
        () => {

          this.labService.getAssociatedLab(this.labService.lab.stateNumber).subscribe(
            assoc => {
              this.labService.associated = assoc;
              this.setupTable();
              this.editMode = 'list';
            },
            error => console.log('error', error),
            () => {
            }
          );
        },
        error => console.log('error: ', error),
        () => {
        }
      );
    }
  }

  rowclick(row: IAssociated) {
    this.editMode = 'edit';
    this.inputLab = row;
    this.inputComments = row.comments;
    this.cliaNumber = row.cliaNumber;
    this.hstLabName = row.labName
    this.stateNumber = row.stateNumber;
    this.hstId = row.hstId;
  }

  cancel() {
    this.editMode = 'list';
    this.inputLab = null;
  }

  delete(): void {
    if (!confirm('Delete this record? Continue?')) {
      return;
    }
    this.inputLab.hstId = this.hstId;

    this.labService.deleteAssociated(this.inputLab.hstId, 'HST').subscribe(
      () => {
        this.labService.getAssociatedLab(this.labService.lab.stateNumber).subscribe(
          assoc => {
            this.labService.associated = assoc;
            this.setupTable();
            this.editMode = 'list';
          },
          error => console.log('error', error),
          () => {
          }
        );
    },
      error => console.log('error: ', error),
      () => {
      }
    );

  }

  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

}